export default "__VITE_ASSET__BvbXP$du__"